/**
 * Created by chenguangpeng on 2018/10/09 17:06
 */
import Caller from './caller'
import Register from './register'

export default {
  ...Caller,
  ...Register
}
